<template>
  <div class="gasConfig">
    <div class='wrapHeader'>
      <el-form :inline="true" :model="selectConfig" class="demo-form-inline">
        <el-form-item label="设备名称">
          <el-input v-model="selectConfig.serName" placeholder="输入设备名称"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="setBgImg" :style="`height:${height}px`">
      <div class="showView" :style="`height:${height-20}px;width:${width-30}px`">
        <div class="setTabView" :style='`height:${height-50}px;width:${width-60}px`'>
          <div class="configList" :style='`height:${height-50}px`'>
            <el-table
              :data='serList'
              style="width:100%"
              border
              :max-height='height-105'
              :header-cell-style='{"background":"rgba(48,56,255,0.03)"}'
              id="cirTable">
              <el-table-column
                prop='serName'
                align='center'
                fixed
                min-width='100' 
                label="设备名称">
              </el-table-column>
              <el-table-column
                prop='wareName'
                align='center'
                min-width='100' 
                label="关联仓房">
              </el-table-column>
              <el-table-column
                align='center' 
                label="磷化氢报警上下限">
                <el-table-column
                  prop='ph3Max'
                  align='center'
                  min-width='90' 
                  label="报警上限">
                </el-table-column>
                <el-table-column
                  prop='ph3Min'
                  align='center'
                  min-width='90' 
                  label="报警下限">
                </el-table-column>
              </el-table-column>
              <el-table-column
                align='center' 
                label="硫酰氟报警上下限">
                <el-table-column
                  prop='so2f2Max'
                  align='center'
                  min-width='90' 
                  label="报警上限">
                </el-table-column>
                <el-table-column
                  prop='so2f2Min'
                  align='center'
                  min-width='90' 
                  label="报警下限">
                </el-table-column>
              </el-table-column>
              <el-table-column
                align='center' 
                label="氧气报警上下限">
                <el-table-column
                  prop='o2Max'
                  align='center'
                  min-width='90' 
                  label="报警上限">
                </el-table-column>
                <el-table-column
                  prop='o2Min'
                  align='center'
                  min-width='90' 
                  label="报警下限">
                </el-table-column>
              </el-table-column>
              <el-table-column 
                prop="status" 
                label="通讯状态" 
                align='center'
                min-width="80">
                <template slot-scope="scope">
                  <span :class='scope.row.status==1?"onLine":"offLine"'>{{scope.row.status==1?"在线":"离线"}}</span>
                </template>
              </el-table-column>
              <el-table-column 
                label="操作" 
                min-width="150" 
                fixed='right'
                align='center'>
                <template slot-scope="scope">
                  <el-button @click.native.prevent="getConfig(serList[scope.$index].gasId,serList[scope.$index].serId,serList[scope.$index].status)" type="text" size="small">修改配置</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <el-pagination
            background
            layout="total,prev, pager, next"
            :total="total" 
            :pageSize='selectConfig.pageSize'
            :hide-on-single-page='true'
            :current-page='selectConfig.pageNum'
            @current-change='pageChange'
            class='setPosition'>
          </el-pagination>
        </div>
      </div>
    </div>
    <el-dialog :title="`${serConfigInfo.serName}配置信息`" :visible.sync="configView"
      :close-on-click-modal='false'
      :custom-class='"dialog-setBg"'>
      <div class='formWrap'>
        <el-form ref="serConfigInfo" :model="serConfigInfo" label-width="125px" :rules='configRules'>
          <div class='dialog-setWrap'>
            <el-form-item label="磷化氢报警上限" prop='ph3Max'>
              <el-input v-model="serConfigInfo.ph3Max"></el-input>
            </el-form-item>
            <el-form-item label="磷化氢报警下限" prop='ph3Min'>
              <el-input v-model="serConfigInfo.ph3Min"></el-input>
            </el-form-item>
            <el-form-item label="硫酰氟报警上限" prop='so2f2Max'>
              <el-input v-model="serConfigInfo.so2f2Max"></el-input>
            </el-form-item>
            <el-form-item label="硫酰氟报警下限" prop='so2f2Min'>
              <el-input v-model="serConfigInfo.so2f2Min"></el-input>
            </el-form-item>
            <el-form-item label="氧气报警上限" prop='o2Max'>
              <el-input v-model="serConfigInfo.o2Max"></el-input>
            </el-form-item>
            <el-form-item label="氧气报警下限" prop='o2Min'>
              <el-input v-model="serConfigInfo.o2Min"></el-input>
            </el-form-item>
          </div>
          <el-form-item class='saveBtn'>
            <el-button type="primary" @click="saveConfig('serConfigInfo')">保存</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import axios from '../../axios.js'
export default {
  props:{
    width:Number,
    height:Number
  },
  data(){
    const compare=(rule,value,callback)=>{
      if(rule.field=='ph3Max'){
        if(Number(this.serConfigInfo.ph3Min)==Number(value)||Number(this.serConfigInfo.ph3Min)>Number(value)){
          callback(new Error("上限要大于下限"))
        }else{
          callback()
        }
      }else if(rule.field=='ph3Min'){
        if(Number(this.serConfigInfo.ph3Max)==Number(value)||Number(this.serConfigInfo.ph3Max)<Number(value)){
          callback(new Error("下限要小于上限"))
        }else{
          callback()
        }
      }else if(rule.field=='so2f2Max'){
         if(Number(this.serConfigInfo.so2f2Min)==Number(value)||Number(this.serConfigInfo.so2f2Min)>Number(value)){
          callback(new Error("上限要大于下限"))
        }else{
          callback()
        }
      }else if(rule.field=='so2f2Min'){
        if(Number(this.serConfigInfo.so2f2Max)==Number(value)||Number(this.serConfigInfo.so2f2Max)<Number(value)){
          callback(new Error("下限要小于上限"))
        }else{
          callback()
        }
      }else if(rule.field=='o2Max'){
        if(Number(this.serConfigInfo.o2Min)==Number(value)||Number(this.serConfigInfo.o2Min)>(value)){
          callback(new Error("上限要大于下限"))
        }else{
          callback()
        }
      }else if(rule.field=='o2Min'){
        if(Number(this.serConfigInfo.o2Max)==Number(value)||Number(this.serConfigInfo.o2Max)<Number(value)){
          callback(new Error("下限要小于上限"))
        }else{
          callback()
        }
      }
    }
    return{
      selectConfig:{
        pageNum:1,
        pageSize:14,
        orderByColumn:'gasId',
        serName:''
      },
      serList:[],
      total:0,
      serConfigInfo:{},
      configView:false,
      configRules:{
        ph3Max:[
          {trigger:'blur',message:'磷化氢上限不能为空',required:true},
          {trigger:'blur',validator:compare}
        ],
        ph3Min:[
          {trigger:'blur',message:'磷化氢下限不能为空',required:true},
          {trigger:'blur',validator:compare}
        ],
        o2Max:[
          {trigger:'blur',message:'氧气上限不能为空',required:true},
          {trigger:'blur',validator:compare}
        ],
        o2Min:[
          {trigger:'blur',message:'氧气下限不能为空',required:true},
          {trigger:'blur',validator:compare}
        ]
      },
      loading:false
    }
  },
  created(){
    this.getSerList()
  },
  methods:{
    getSerList(){
      axios.get('/system/gas/list',{params:this.selectConfig}).then(res=>{
        if(res){
          this.serList=res.rows;
          this.total=res.total
        }
      })
    },
    getConfig(gasId,serId,status){
      if(status==1){
        axios.get(`/system/gas/${gasId}`).then(res=>{
          if(res){
            this.configView=true;
            this.serConfigInfo=res.data;
          }
        })
      }else{
        this.$message({
          message:'不能配置离线设备！',
          type:'error',
          duration:1000
        })
      }
    },
    // 设置加载动画
    setLoading(){
      this.loading=this.$loading({
        text:'请稍等',
        target:document.querySelector('.dialog-setBg')
      })
    },
    saveConfig(formName){
      this.$refs[formName].validate(valid=>{
        if(valid){
          this.setLoading();
          axios.put('/system/gas/setupGas',this.serConfigInfo).then(res=>{
            this.loading.close();
            if(res){
              this.getSerList()
              this.$message({
                type: 'success',
                message: '配置成功!',
                duration:1000
              });
              this.configView=false
            }
          })
        }else{
          return false
        }
      })
    },
    pageChange(val){
      this.selectConfig.pageNum=val;
      this.getSerList()
    }
  }
}
</script>

<style lang="scss" scoped>
.gasConfig{
  .configList{
   border: 1px solid #e4e7ed;
    padding: 10px;
    box-sizing: border-box;
    overflow: auto
  }
  #cirTable .el-table__body-wrapper::-webkit-scrollbar{
    width: 10px !important;
    height: 10px !important;
  }
  .onLine{color: #3BD14A}
  .offLine{color: #AFAFAF}
}
</style>
